import { removeEmptyNullAndUndefinedFromObject } from "../../utils/common";

/** */
const buildEndPoint = (params, basePath) => {
  const options = {
    pageType: params?.pageType || "dateRange",
    categoryId: params?.categoryId || "",
    productId: params?.productId || "",
    month: params?.month || "",
    year: params?.year || "",
    domainId: "fnp.com",
    page: params?.pageNumber || 0,
    size: 20,
    requestType: "",
  };
  const filteredParams = removeEmptyNullAndUndefinedFromObject(options);
  const flattenedParams = new URLSearchParams(filteredParams).toString();
  return `${basePath}?${decodeURIComponent(flattenedParams)}`;
};

/**
 * Endpoint for fetching testimonials.
 *
 * @param {object} params - Parameters for the endpoint.
 * @returns {string} The URL of the API endpoint to fetch testimonials.
 */
export const testimonialsEndPoint = (params) => {
  return buildEndPoint(params, "/moody/v1/testimonials");
};
/**
 * Endpoint for fetching ratings.
 *
 * @param {object} params - Parameters for the endpoint.
 * @returns {string} The URL of the API endpoint to fetch ratings.
 */
export const ratingsEndPoint = (params) => {
  const basePath =
    params?.pageType === "category"
      ? "/moody/v1/category/ratings"
      : params?.pageType === "product"
        ? "/moody/v1/product/rating"
        : "/moody/v1/testimonials";
  return buildEndPoint(params, basePath);
};
